import dayjs from '../../../utils/dayjs';
import { Badge, Card, DataTable, Link, Text } from '@shopify/polaris';
import helpers from 'helpers/index';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ENUM_ORDER_PAYMENT_STATUS, ENUM_ORDER_STATUS, TypedOrders, useGetOrders } from 'queries/orders.query';

import SimpleFilter from 'components/simpleFilter';
import Pagination from 'components/pagination';
import { getOrderStatus } from 'entities/orders/order.util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export default function CustomerTicketList() {
  /**
   * Get all campaign this customer belong to...
   */
  let { customer_id } = useParams();
  const initialQuery = {
    limit: 20,
    customer_id: customer_id,
    sort: 'departure_date:desc',
    page: 1,
  };
  const [mainQuery, setMainQuery] = useState(initialQuery);

  const { data, isLoading } = useGetOrders(mainQuery);

  const [totalItems, setTotalItems] = useState<number>(0);
  const [entities, setEntities] = useState<TypedOrders[]>([]);
  useEffect(() => {
    if (data) {
      setEntities(data.entities);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  return (
    <>
      <Card padding="0">
        {entities?.length > 0 ? (
          <>
            <SimpleFilter
              onCallback={filterCallback}
              loading={isLoading}
              options={[]}
              // options={[{ label: 'Chưa diễn ra', value: `gte:${new Date(new Date().setHours(0)).getTime()}`, field: 'trip.DepartureTimeTimestamp' }]}
              sortField={[
                {
                  label: 'Ngày đi',
                  field: 'departure_date',
                },
              ]}
            />
            <DataTable
              verticalAlign="middle"
              stickyHeader={false}
              columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'numeric']}
              headings={[
                'Code',
                'Ngày đi',
                'T.toán',
                'H.Đơn',
                'TT.Vận chuyển',
                'Hành trình',
                'Số vé',
                'Chuyến',
                'Đón/trả',
                'Số tiền',
                'Ghi chú',
                'Người đặt',
                'Thanh toán',
                'Ngày tạo',
              ]}
              rows={entities?.map((order) => {
                const {
                  id,
                  order_code,
                  departure_date,
                  dropoff_address,
                  pickup_address,
                  journey,
                  total_must_pay,
                  note,
                  author_data,
                  order_status,
                  payment_status,
                  journey_id,
                  createdAt,
                  total_seat,
                  order_meta,
                  trip_manifest,
                  invoices,
                  ticket,
                } = order;

                let trip_hour = dayjs(new Date(Number(departure_date))).format('HH:mm');
                let trip_date_reformat = dayjs(new Date(Number(departure_date))).format('YYYY-MM-DD');

                let allDrivers = trip_manifest?.trip_manifest_driver || null;

                return [
                  <Link url={`/orders/view/${id}`}>
                    <strong>{order_code}</strong>
                  </Link>,

                  <>
                    <Text as="h3" variant="headingMd">
                      {trip_hour}
                    </Text>
                    <Text as="p" tone="subdued">
                      {trip_date_reformat}
                    </Text>
                  </>,

                  order_status === ENUM_ORDER_STATUS.CANCELLED ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--card2)" />
                  ) : payment_status === ENUM_ORDER_PAYMENT_STATUS.PAID ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--green2)" />
                  ) : payment_status === ENUM_ORDER_PAYMENT_STATUS.PARTIALLY_PAID ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--p-color-icon-caution)" />
                  ) : (
                    <FontAwesomeIcon icon={faCircle} color="var(--bad)" />
                  ),

                  order_status === ENUM_ORDER_STATUS.CANCELLED ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--card2)" />
                  ) : !invoices ? (
                    <FontAwesomeIcon icon={faCircle} color="var(--bad)" />
                  ) : (
                    <FontAwesomeIcon icon={faCircle} color="var(--green2)" />
                  ),

                  getOrderStatus(order_status),

                  journey ? <Text as="span">{journey?.journey_name}</Text> : '--',
                  total_seat,
                  !helpers.isEmpty(allDrivers)
                    ? allDrivers.map((al: any) => (
                        <div>
                          {al.driver_data.display_name} ({al.driver_data.user_phonenumber})
                        </div>
                      ))
                    : '-',
                  <>
                    <Text as="p">{pickup_address ?? '--'}</Text>
                    <Text as="p">{dropoff_address ?? '--'}</Text>
                  </>,

                  helpers.formatNumber(total_must_pay),

                  note ?? '--',
                  author_data?.display_name ?? '--',
                  <Badge tone={payment_status === ENUM_ORDER_PAYMENT_STATUS.UNPAID ? 'critical' : payment_status === ENUM_ORDER_PAYMENT_STATUS.PAID ? 'success-strong' : 'attention'}>
                    {payment_status === ENUM_ORDER_PAYMENT_STATUS.UNPAID ? 'CHƯA THANH TOÁN' : payment_status === ENUM_ORDER_PAYMENT_STATUS.PAID ? 'ĐÃ THANH TOÁN' : 'THANH TOÁN MỘT PHẦN'}
                  </Badge>,
                  <>
                    <Text as="h3" variant="headingMd">
                      {dayjs(new Date(Number(createdAt))).format('HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dayjs(new Date(Number(createdAt))).format('DD-MM-YYYY')}
                    </Text>
                  </>,
                ];
              })}
              hideScrollIndicator
              hasZebraStripingOnData
              increasedTableDensity
            />
          </>
        ) : null}
      </Card>

      <br />
      {totalItems > 0 ? (
        <Pagination
          TotalRecord={totalItems}
          onChange={onChangePagination}
          pageSize={Number(mainQuery.limit)}
          activeCurrentPage={Number(mainQuery.page)}
        />
      ) : null}
    </>
  );
}
